import { Icon } from '@blueprintjs/core';
import { useDebouncedState, useEventListener } from '@mantine/hooks';
import { zIndexes } from '@styles/zindex/zindex';
import { ScrollButton, StyledDialog } from './ScrollToTop.styles';

interface ScrollToTopProps {
  elementRef: React.RefObject<HTMLElement | null>;
}
export function ScrollToTop({ elementRef }: ScrollToTopProps) {
  const [scrollTop, setScrollTop] = useDebouncedState(0, 300);
  function checkScroll(this: HTMLElement) {
    // eslint-disable-next-line react/no-this-in-sfc
    setScrollTop(this.scrollTop);
  }
  const ref = useEventListener<'scroll', HTMLElement>('scroll', checkScroll);
  if (elementRef.current) ref.current = elementRef.current;

  if (scrollTop < 40) return null;

  return (
    <StyledDialog
      className="reset-global new-icon"
      opened
      zIndex={zIndexes.indexOf('scroll-to-top')}
      position={{ right: 24, bottom: 24 }}
    >
      <ScrollButton
        onClick={() =>
          elementRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
        }
      >
        <Icon icon="arrow-up" />
      </ScrollButton>
    </StyledDialog>
  );
}
